export const INTERCEPT_MLS = {
    // SITE - 15435  SITE-16247  CHIME-21882
    listingId: [128, 383, 588, 439, 441],
    // CHIME-21882
    soldDate: [588],
    soldPrice: [588],
    hiddenUpdateTime: [588, 383]
};

export const INTERCEPT_URL = {
    leadRegister: '/api-site/leadRegister',
    updatePhone: '/api-site/profile/update/phoneNumber'
};

